/* unplugin-vue-components disabled */import { render } from "./HmPrivacyPolicy.vue?vue&type=template&id=5c61be3a&scoped=true"
import script from "./HmPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./HmPrivacyPolicy.vue?vue&type=script&lang=js"

import "./HmPrivacyPolicy.vue?vue&type=style&index=0&id=5c61be3a&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c61be3a"]])

export default __exports__